export default __webpack_public_path__ + "static/IN-8015HD-vs-IN-6014HD_nightBig-06e2d6cbf0fb439b95541171e1b0fed8.webp";